import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["align", "alignSelf", "children", "columnType", "expands", "overflow"];
import styled from 'foundations-theming/utils';
import { forwardRef } from 'react';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { filterProps } from '../../../utils/filterProps';
import { jsx as _jsx } from "react/jsx-runtime";
const WrapperColumnStyles = styled.div.withConfig({
  displayName: "AbstractColumn__WrapperColumnStyles",
  componentId: "zot6h7-0"
})(({
  $align,
  $alignSelf,
  $cssStyles
}) => {
  return Object.assign({
    display: 'inline-flex',
    justifyContent: 'space-between',
    inlineSize: '100%',
    wordBreak: 'break-word',
    overflow: 'visible',
    alignItems: $align,
    alignSelf: $alignSelf
  }, $cssStyles);
});
const SpreadsColumnStyles = styled.div.withConfig({
  displayName: "AbstractColumn__SpreadsColumnStyles",
  componentId: "zot6h7-1"
})(({
  $align,
  $alignSelf,
  $expands,
  $overflowVisible,
  $cssStyles
}) => {
  return Object.assign({
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 100000,
    inlineSize: '100%',
    overflowX: 'auto',
    overflowY: 'hidden',
    whiteSpace: 'normal',
    alignItems: $align,
    alignSelf: $alignSelf
  }, $expands && {
    flexGrow: 1
  }, $overflowVisible && {
    overflow: 'visible'
  }, $cssStyles);
});
const ContentColumnStyles = styled.div.withConfig({
  displayName: "AbstractColumn__ContentColumnStyles",
  componentId: "zot6h7-2"
})(({
  $align,
  $alignSelf,
  $cssStyles
}) => {
  return Object.assign({
    display: 'flex',
    flexWrap: 'nowrap',
    flexGrow: 0,
    flexShrink: 1,
    alignItems: $align,
    alignSelf: $alignSelf,
    '> *': {
      flexShrink: 0
    }
  }, $cssStyles);
});
export const AbstractColumn = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      align = 'start',
      alignSelf,
      children,
      columnType,
      expands,
      overflow
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  let ColumnWrapper;
  if (columnType === 'wrapper') {
    ColumnWrapper = WrapperColumnStyles;
  } else if (columnType === 'content') {
    ColumnWrapper = ContentColumnStyles;
  } else {
    ColumnWrapper = SpreadsColumnStyles;
  }
  return /*#__PURE__*/_jsx(ColumnWrapper, Object.assign({}, domProps, {
    ref: ref,
    $cssStyles: cssStyles,
    $align: align,
    $alignSelf: alignSelf,
    $expands: expands,
    $overflowVisible: overflow,
    children: children
  }));
});
AbstractColumn.displayName = 'AbstractColumn';